
import moment from 'moment'
import { TABLA_DESCARGA_PROCESADA } from '../../../../../config/tables'
import { TablaDescargaProcesadaEnStockService } from '../servicio/tabla_descarga_procesada_en_stock'
import { getColumnasDescargaProcesada, DESCARGA_PROCESADA_STOCK_TO_PRINT } from './constantesDescargaProcesadaEnStock'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable (fechaD, fechaH, roles) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DESCARGA_PROCESADA
    })

    const fechaDesde = moment(fechaD).format('DD-MM-YYYY')
    const fechaHasta = moment(fechaH).format('DD-MM-YYYY')
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR')

    TablaDescargaProcesadaEnStockService.getDataTablaDescargaProcesadaEnStock(fechaDesde, fechaHasta).then(callback)
    function callback (result) {
      const data = []
      result.forEach(d => { data.push({ ...d, numero: d.cartaDePorte }) })
      const customToolbar = pdfCustomToolbarGenerator(
        'Descarga procesada en stock',
        data,
        DESCARGA_PROCESADA_STOCK_TO_PRINT,
        'landscape'
      )
      const textRowCount = 'Cantidad de procesados: '
      const columnas = getColumnasDescargaProcesada(rol)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Descarga procesada en stock`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            tableBodyMaxHeight: '489px',
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLA_DESCARGA_PROCESADA
      })
    }
  }
}
